import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import CheckboxStyled from 'components/CheckboxStyled';
import React from 'react';
import { useCookies } from 'react-cookie';
import styled from 'styled-components';
import { ICommonCode } from 'utils/types/storyTypes';

interface IProps {
  data: ICommonCode;
  setItemFilter: React.Dispatch<React.SetStateAction<string[]>>;
  itemFilter: string[];
}

const ItemFilterCheckBox: React.FC<IProps> = ({
  data,
  setItemFilter,
  itemFilter,
}) => {
  const handleOnChange = (isChecked: boolean, value: string) => {
    console.log(`ItemFilterCheckBox : `, value);

    let cloneFilter = structuredClone(itemFilter); // 현재 필터 클론
    if (isChecked) {
      if (!cloneFilter.includes(value)) cloneFilter.push(value);
    } else {
      cloneFilter = cloneFilter.filter((item) => item != value);
    }

    setItemFilter(cloneFilter);
  };
  return (
    <Wrapper>
      <Checkbox
        checked={itemFilter.includes(data.code)}
        onChange={(e) => handleOnChange(e.target.checked, data?.code)}
      />
      <p>{data?.code_name}</p>
    </Wrapper>
  );
};

export default ItemFilterCheckBox;

const Wrapper = styled.div`
  display: flex;
  & > * + * {
    margin-left: 10px;
  }
`;
